// extracted by mini-css-extract-plugin
module.exports = {"Table":"PreviewWeatherDataModal_Table__23k8g","KendoGrid":"PreviewWeatherDataModal_KendoGrid__tuYDZ"};